import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog } from '../types'
import { CmsConverterService, defaultFSCatalog } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class FullWidthGalleryContainerConverter extends CmsConverterService<FullWidthGalleryContainerData> {
  convertData (source: CmsComponent) {
    return {
      items: source?.otherProperties?.formData.st_items ?? defaultFSCatalog,
    }
  }
}

export const FULL_WIDTH_GALLERY_CONTAINER_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, FullWidthGalleryContainerData>>('FullWidthGalleryContainerConverter')

export interface FullWidthGalleryContainerData extends ConvertedComponentData {
  items: FsCatalog;
}
